import BaseUtil from "../../util/BaseUtil";
import BusinessConstants from "../../constant/BusinessConstants";
const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    loading: false
}

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};
export default viewModel;
